// extracted by mini-css-extract-plugin
module.exports = {"itemWrapper":"styles_itemWrapper__j2axd","listItem":"styles_listItem__ckH45"};